module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "exampleModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('gmap-map', {
    ref: "mymap",
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "center": _vm.startLocation,
      "zoom": 15
    }
  }, [_c('gmap-info-window', {
    attrs: {
      "options": _vm.infoOptions,
      "position": _vm.infoPosition,
      "opened": _vm.infoOpened
    },
    on: {
      "closeclick": function($event) {
        _vm.infoOpened = false
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.infoContent) + "\n            ")]), _vm._v(" "), _vm._l((_vm.coordinates), function(item, key) {
    return _c('gmap-marker', {
      key: key,
      attrs: {
        "position": _vm.getPosition(item),
        "clickable": true
      },
      on: {
        "click": function($event) {
          return _vm.toggleInfo(item, key)
        }
      }
    })
  })], 2)], 1)])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "tableBox"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('v-server-table', {
    ref: "livedetailsTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "map",
      fn: function(props) {
        return [_c('div', [_c('button', {
          staticClass: "btn gradientbt",
          attrs: {
            "type": "button",
            "data-toggle": "modal",
            "data-target": "#exampleModal"
          },
          on: {
            "click": function($event) {
              return _vm.getstartLocation(props.row)
            }
          }
        }, [_vm._v("\n          Show Map\n        ")])])]
      }
    }])
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50a431de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/VehicleStatus/VehicleStatus.vue
// module id = 2328
// module chunks = 1